<div class="w-4/5 mx-auto">
  <input
    [formControl]="inputControl"
    [value]="inputControl.value"
    placeholder="Tên chương"
    class="sm:text-2xl text-gray-700 font-medium input__chapter text-center py-4 mb-8 w-full"
  />
  <ng-content></ng-content>
</div>
